import { Box, Button, Stack, Theme, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import React, { FC, ReactNode } from 'react'

export type InformationModalProps = {
  title: string | ReactNode
  content: string | ReactNode
  buttons?: ReactNode
  cancelText?: string
  sx?: SxProps<Theme>
  innerSx?: SxProps<Theme>
}

export const RequiredMembershipRecommendBox: FC<InformationModalProps> = ({
  title,
  content,
  buttons,
  cancelText,
  sx,
  innerSx,
}) => {
  return (
    <Box
      id="modal-inner"
      sx={{
        width: 280,
        borderRadius: 3,
        px: 5,
        py: 7,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'grey.100',
        outline: 'none',
        textAlign: 'center',
        ...Object.assign({}, sx, innerSx),
      }}
    >
      {typeof title === 'string' ? (
        <Typography variant="h5" sx={{ pb: 3 }}>
          {title}
        </Typography>
      ) : (
        title
      )}
      {typeof content === 'string' ? (
        <Typography variant="body2" sx={{ pb: 7 }}>
          {content}
        </Typography>
      ) : (
        content
      )}
      <Stack spacing={4} alignItems="center">
        {buttons}
        {cancelText && (
          <Button variant="text" color="primary">
            {cancelText}
          </Button>
        )}
      </Stack>
    </Box>
  )
}
